import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { ScrollToTop } from '../../../../lib/components/ScrollToTop/ScrollToTop';
import { AppHeader } from '../AppHeader/AppHeader';
import { AppFooter } from '../AppFooter/AppFooter';
import { SideNav } from '../SideNav/SideNav';
import { StyledLegacyAppLayout } from './LegacyAppLayout.styles';
import { ScrollToTopButton } from 'lib/components/ScrollToTopButton/ScrollToTopButton';
import { VncV2 } from 'app/components/Vnc/components/VncV2';
import { VncSelectors } from 'app/components/Vnc/state/vncSelectors';
import {
  selectIsCheckingAuthentication,
  selectIsLoggedIn,
} from 'app/cross-cutting-concerns/authentication/state/authenticationSelectors';
import { MachineDetailsDrawer } from 'app/cross-cutting-concerns/drawers/components/MachineDetailsDrawer/MachineDetailsDrawer';
import { SiteDetailsDrawer } from 'app/cross-cutting-concerns/drawers/components/SiteDetailsDrawer/SiteDetailsDrawer';
import {
  LOCAL_STORAGE_VNC_KEY,
  LOCAL_STORAGE_VNC_ROBOT_SOFTWARE_VERSION_KEY,
  LOCAL_STORAGE_VNC_SERIAL_NUMBER,
} from 'config/constants';

const { Content } = Layout;

export const LegacyAppLayout = (): JSX.Element => {
  const containerRef = useRef<HTMLDivElement>(null);

  const machineIdLocalStored = localStorage.getItem(LOCAL_STORAGE_VNC_KEY);

  const isVncWindowOpen = useSelector(VncSelectors.selectVncWindowIsOpen);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const isCheckingAuthentication = useSelector(selectIsCheckingAuthentication);

  const isVncComponentAvailable = useMemo(
    () => (machineIdLocalStored || isVncWindowOpen) && isLoggedIn,
    [machineIdLocalStored, isVncWindowOpen, isLoggedIn]
  );

  useEffect(() => {
    if (!isLoggedIn && !isCheckingAuthentication) {
      localStorage.removeItem(LOCAL_STORAGE_VNC_KEY);
      localStorage.removeItem(LOCAL_STORAGE_VNC_SERIAL_NUMBER);
      localStorage.removeItem(LOCAL_STORAGE_VNC_ROBOT_SOFTWARE_VERSION_KEY);
    }
  }, [isLoggedIn, isCheckingAuthentication]);

  return (
    <StyledLegacyAppLayout className="layout">
      <AppHeader />
      <Layout hasSider>
        <SideNav />
        <ScrollToTop containerRef={containerRef} />
        <Layout className="layout-content">
          <Content className="app-layout__content">
            <div ref={containerRef} className="outlet-wrapper">
              <Outlet />
              {isVncComponentAvailable ? <VncV2 /> : null}
              <MachineDetailsDrawer />
              <SiteDetailsDrawer />
            </div>
            <AppFooter>
              <ScrollToTopButton containerRef={containerRef} />
            </AppFooter>
          </Content>
        </Layout>
      </Layout>
    </StyledLegacyAppLayout>
  );
};
